import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'components';
import { modalTypes } from 'constant';

import './style.scss';

function AssignmentRequestModal({
  isVisible = false,
  onOverlayClick = () => {},
  onClick = () => {},
  onClose = () => {},
  title = 'Godkänn allmänna villkor',
  modalType = modalTypes.APPROVE,
  children = (
    <p>
      Genom att acceptera uppdraget godkänner du våra allmänna villkor och
      riktlinjer för tolkuppdrag
    </p>
  ),
  acceptanceButtonLabel = 'Acceptera uppdraget',
  rejectButtonLabel = 'Avbryt',
}) {
  return (
    <Modal
      className="tv-assignment-request-modal__container"
      hideHeader
      onClose={onClose}
      onOverlayClick={onOverlayClick}
      isVisible={isVisible}
    >
      <h2 className="tv-assignment-request-modal__title">{title}</h2>
      {children}
      <div className="tv-assignment-request-modal__actions">
        <Button
          onClick={onClose}
          className="tv-assignment-request-modal__button"
          palette="outline"
          label={rejectButtonLabel}
        />
        <Button
          onClick={() => onClick(modalType)}
          className="tv-assignment-request-modal__button"
          label={acceptanceButtonLabel}
        />
      </div>
    </Modal>
  );
}

AssignmentRequestModal.propTypes = {
  isVisible: PropTypes.bool,
  onOverlayClick: PropTypes.func,
  onClose: PropTypes.func,
  onClick: PropTypes.func,
  modalType: PropTypes.string,
  title: PropTypes.string,
  acceptanceButtonLabel: PropTypes.string,
  rejectButtonLabel: PropTypes.string,
  children: PropTypes.node,
};

export default AssignmentRequestModal;
